module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "market"
  }, [_c('platform'), _vm._v(" "), _c('com-list', {
    attrs: {
      "data": _vm.services,
      "title": "我们提供的营销服务",
      "subtitle": "为企业提供技术产品的推广、销售线索的获取、技术品牌的打造、开发者生态的共建等"
    }
  }), _vm._v(" "), _c('com-partner', {
    attrs: {
      "partners": _vm.partners
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-175eda9b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/training/market/market.vue
// module id = 441
// module chunks = 1